module.exports = __webpack_public_path__ + "media/images/apple-icon-120x120-23d285b7.png";